<div class="flex flex-col gap-2 p-6">
  <h3>Delete Recurring Transaction</h3>

  <p class="font-bold text-night">Are you sure you want to delete this recurring transaction?</p>

  <form [formGroup]="form">
    <div class="flex items-center gap-2">
      <mat-checkbox formControlName="deleteRelated">
        Delete all unlocked transactions created by this recurring transaction?
        <span class="text-night-lighter">
          ({{ data.deletableTransactionsCount }} transaction{{ data.deletableTransactionsCount === 1 ? '' : 's' }})
        </span>
      </mat-checkbox>
    </div>
  </form>

  <div class="flex justify-end items-center gap-2 mt-4">
    <sbnb-button type="secondary" (clicked)="onCancel()">Cancel</sbnb-button>
    <sbnb-button type="primary" (clicked)="onConfirm()">Delete</sbnb-button>
  </div>
</div>
